import { useQuery } from '@tanstack/react-query'
import { fetchClientTeam } from '@/lib/api/universe'

/** The client's planned team spans, from the allocation plan. */
export function useClientTeam(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client-team', clientId],
    queryFn: () => fetchClientTeam(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60_000,
  })
}
